import React from 'react'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import Icon from '@forwardflow/ui/Icons'
import { Avatar, message } from 'antd'
import { UserAvatar } from '@forwardflow/ui'
import { getAvatarColor } from '@forwardflow/helpers/utils'
import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'

dayjs.extend(duration)

interface CallMissedItemProps {
   item: any
   selectedLeadDetails: any
}

export const CallMissedItem: React.FC<CallMissedItemProps> = ({
   item,
   selectedLeadDetails
}) => {
   const { data: user } = useAuthUser({ revalidateOnMount: true })
   const isIncoming = item?.isIncoming

   const handleCopy = () => {
      navigator.clipboard.writeText(item?.stepId).then(() => {
         message.success('Copied to clipboard')
      })
   }

   return (
      <div className={`flex ${isIncoming ? 'justify-start' : 'justify-end'}`}>
         <div className={`flex flex-col overflow-hidden gap-x-2 rounded-3xl max-w-[800px] 3xl:w-[800px] ${isIncoming ? 'items-start rounded-bl-none' : 'items-end rounded-br-none'
            }`}>
            <div className='flex flex-col bg-[#944047] py-4 px-8 w-full relative group'>
               {user?.email === 'operator@forward-flow.com' &&
                  item?.stepId && (
                     <div className="text-[11px] text-white/70 px-0 pb-3 flex gap-x-4">
                        <span
                           className="cursor-pointer select-all"
                           title="Click to copy"
                           onClick={handleCopy}
                        >
                           Step Id:{' '}
                           <span className="text-[12px] font-medium">
                              {item?.stepId}
                           </span>
                        </span>
                        {item?.campaignPhase && (
                           <span>
                              Phase:{' '}
                              <span className="text-[12px] font-medium">
                                 {item?.campaignPhase}
                              </span>
                           </span>
                        )}
                        {item?.campaignType && (
                           <span>
                              Type:{' '}
                              <span className="text-[12px] font-medium">
                                 {item?.campaignType}
                              </span>
                           </span>
                        )}
                     </div>
                  )}

               <div className={`flex justify-between ${isIncoming ? 'flex-row' : 'flex-row-reverse'}`}>
                  <div className="flex items-center">
                     {isIncoming ? (
                        <>
                           <UserAvatar
                              backgroundColor={getAvatarColor(
                                 selectedLeadDetails?.stageInfo?.name
                              )}
                              className="!w-10 !h-10 !text-[14px] shrink-0"
                           >
                              {selectedLeadDetails?.userInfo?.firstName.slice(0, 1) || 'L'}
                           </UserAvatar>
                           <div className="ml-4 text-left">
                              <p className="text-[12px] mb-1">No Answer</p>
                              <p className="text-white/70 text-[12px]">
                                 {dayjs(item?.ts).format('h:mm A, D MMM YYYY')}
                              </p>
                           </div>
                        </>
                     ) : (
                        <>
                           <div className="mr-4 text-right">
                              <p className="text-[12px] mb-1">No Answer</p>
                              <p className="text-white/70 text-[12px]">
                                 {dayjs(item?.ts).format('h:mm A, D MMM YYYY')}
                              </p>
                           </div>
                           <Avatar
                              src={'/images/ff_white.png'}
                              className="w-10 h-10 p-1 shrink-0 bg-primary-dark/80"
                           >
                              {item?.assistant?.name.slice(0, 1) || 'A'}
                           </Avatar>
                        </>
                     )}
                  </div>
                  <div className="flex-1">
                     <div className={`flex ${isIncoming ? 'justify-end' : 'justify-start'}`}>
                        <div className="h-10 px-4 py-2 rounded-full flex gap-x-3 bg-black/20 shrink-0">
                           <Icon name="MissedCall" className="fill-white" />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}